const apiBaseUrl = (
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_BASE_URL ||
  ''
).replace(/\/$/, '');

export function getUserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'UTC';
  }
}

export async function verifyTicketStatusApi(data) {
  const url = new URL(`${apiBaseUrl}/user/payment/scan-ticket`);
  Object.entries({
    ...data,
    userTimezone: data.userTimezone ?? getUserTimezone(),
  }).forEach(([key, value]) => {
    if (value != null && value !== '') url.searchParams.set(key, value);
  });

  const response = await fetch(url.toString(), {
    headers: { 'Content-Type': 'application/json' },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.message || `Ticket check failed (${response.status})`);
    error.response = { data: payload, status: response.status };
    throw error;
  }
  return { data: payload };
}

export async function updateTicketNamesApi(ticketId, { first_name, last_name }) {
  if (!ticketId) throw new Error('Invalid ticket data.');

  const url = new URL(`${apiBaseUrl}/user/payment/update-ticket`);
  url.searchParams.set('ticketId', ticketId);

  const response = await fetch(url.toString(), {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      first_name,
      last_name: last_name || ' ',
    }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.message || `Could not save the name (${response.status})`);
  }
  return { data: payload };
}
